import { getFragment } from '../../graphql';
import type { OfferFragment } from '../../types';

export const getOfferProdct = (offer?: OfferFragment) =>
    offer && offer?.product?.__typename === 'Product'
        ? getFragment(offer.product)
        : undefined;
